export enum SideBarIndex {
  None, Search, LayerList, Legend, Printer
}
